import React, {useEffect, useState} from "react";
import renderMirador from "../../config/miradorConfig";
import Footer from "../../components/Footer/Footer";
import BreadCrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import './ViewerPage.css';
import './Mirador.css';
import {useHistory, useParams} from "react-router-dom";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import process from "webpack-cli/bin/.eslintrc";

const ViewerPage = () => {
    const {astorId, pageId} = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const history = useHistory();

    const getPageIdFromUrl = () => {
        if (pageId) {
            return pageId.includes(",") ? pageId.split(",")[0] : pageId;
        }
        return null;
    };

    const getViewType = () => {
        return pageId?.includes(",") ? 'book' : 'single';
    };

    const fetchManifestOrRedirect = async () => {
        const manifestUrl = process.env.REACT_APP_MANIFEST_URL + astorId;

        try {
            const response = await fetch(manifestUrl);
            if (response.ok) {
                const manifestData = await response.json();
                const parts = manifestData.id.split('/');
                const correctAstorId = parts[parts.length - 1];

                if (correctAstorId !== astorId) {
                    // Redirect if the IDs don't match
                    history.push(pageId ? `/${correctAstorId}/${pageId}` : `/${correctAstorId}/`);
                    return false;
                }

                document.title = manifestData.label.none[0];

                return true;
            } else {
                let errorMessage;
                let showOnbLinks = false;
                switch (response.status) {
                    case 400:
                    case 404:
                        errorMessage = "Leider ist dieser Link ungültig.";
                        showOnbLinks = true;
                        break;
                    case 500:
                        errorMessage =
                            "Leider ist ein Problem aufgetreten, bitte probieren Sie es zu einem späteren Zeitpunkt wieder.";
                        break;
                    default:
                        errorMessage = "Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.";
                }
                history.push({
                    pathname: "/error",
                    state: {
                        message: errorMessage,
                        status: response.status,
                        showOnbLinks: showOnbLinks,
                    }
                })
                return false;
            }
        } catch (error) {
            history.push({
                pathname: "/error",
                state: {
                    message: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.",
                    status: "500",
                }
            })
            return false;
        }
    };

    useEffect(() => {
        let isMounted = true;

        const loadResource = async () => {
            const isAvailable = await fetchManifestOrRedirect();
            if(isMounted) {
                setIsLoading(false);
            }

            if (isAvailable) {
                const manifestId = process.env.REACT_APP_MANIFEST_URL + astorId;
                const pageId = getPageIdFromUrl();
                const canvasId = pageId ? `${manifestId}/canvas/${pageId}` : '';
                const viewType = getViewType();

                const viewerContainer = document.getElementById('viewer');
                if (viewerContainer) {
                    renderMirador({
                        id: "viewer",
                        language: "de",
                        annotations: {
                            filteredMotivations: ['oa:commenting', 'oa:tagging', 'sc:painting', 'commenting', 'tagging', 'supplementing'],
                        },
                        windows: [
                            {
                                imageToolsEnabled: true,
                                imageToolsOpen: false,
                                manifestId: manifestId,
                                canvasId: canvasId,
                                view: viewType,
                            },
                        ],
                    });
                }
            }


        };

        loadResource();

        return () => {
            isMounted = false;
        }

    }, [astorId, pageId]); // Trigger fetch again if astorId or pageId change

    return (
        <>
            <BreadCrumbs/>
            {isLoading ? (
                <div className="outer-container">
                    <div className="inner-container">
                        <LoadingSpinner/>
                        <Footer/>
                    </div>
                </div>
            ) : (
                <div>
                    <div id="viewer"></div>
                    <Footer/>
                </div>
            )}

        </>
    )
        ;
};

export default ViewerPage;
